import { toast } from "react-toastify"

import { api } from "~/utils/api"
import { showErrorToast } from "~/utils/toaster"

export const useGetTags = () => api.tags.get.useQuery()

export const useGetTagsOnSkuIds = (skuIds: string[]) =>
  api.tagOnSku.getTagsOnSkuIds.useQuery({ skuIds: skuIds.length > 500 ? [] : skuIds })

export const useCreateTag = () => {
  const utils = api.useUtils()

  return api.tags.add.useMutation({
    onSuccess: (res, req) => {
      utils.tags.get.invalidate()
      toast.success(`Tag '${req.name}' created`)
      return res
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useUpdateTagsOnSkus = () => {
  const utils = api.useUtils()

  return api.tagOnSku.updateTagsOnSkus.useMutation({
    onSuccess: (_, req) => {
      utils.tagOnSku.getTagsOnSkuIds.invalidate()
      utils.variantTableData.variants.invalidate()
      utils.sku.getDataForPOs.invalidate()
      utils.npi.variants.invalidate()
      toast.success(`Tags updated on ${req.variantCount ?? req.skuIds.length} variants`)
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useRemoveTagOnSkus = () => {
  const utils = api.useUtils()

  return api.tagOnSku.removeTagOnSkus.useMutation({
    onSuccess: (_, req) => {
      utils.tagOnSku.getTagsOnSkuIds.invalidate()
      utils.variantTableData.variants.invalidate()
      utils.sku.getDataForPOs.invalidate()
      utils.npi.variants.invalidate()
      toast.success(`Tag removed from ${req.variantCount ?? req.skuIds.length} variants`)
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useDeleteTag = () => {
  const utils = api.useUtils()

  return api.tags.delete.useMutation({
    onSuccess: () => {
      utils.tags.get.invalidate()
      utils.tagOnSku.getTagsOnSkuIds.invalidate()
      utils.variantTableData.variants.invalidate()
      utils.sku.getDataForPOs.invalidate()
      utils.npi.variants.invalidate()
      toast.success("Tag deleted")
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useUpdateTag = () => {
  const utils = api.useUtils()

  return api.tags.update.useMutation({
    onSuccess: () => {
      utils.tags.get.invalidate()
      utils.variantTableData.variants.invalidate()
      utils.sku.getDataForPOs.invalidate()
      utils.npi.variants.invalidate()
      toast.success("Tag renamed")
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}
